import Axios from 'axios'
import { codePointAt } from 'core-js/fn/string'
import router from '../router'

export default {
  state: {
    imc: null,
    img: null
  },
  getters: {
    img(state) {
      return state.img
    },
    imc(state) {
      return state.imc
    },
  },
  mutations: {},
  actions: {
    async loadUser({ commit }, payload) {
      commit('setLoading')
      await Axios.get(process.env.VUE_APP_API_URL_LOAD_USER + payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        })
        .then(res => {
          commit('setLoading');
          commit('setUser', JSON.parse(JSON.stringify(res.data.data)));
          localStorage.setItem('currentUser', JSON.stringify(res.data.data));
        }
        ).catch(error => {
          commit('clearError');
          commit('setError', error);
          commit('setLoading');
        });
    },
    async updateUser({ commit }, payload) {
      commit('setLoading')
      if ('newEmail' in payload)
        payload.mail = payload.newEmail.toLowerCase();

      await Axios.put(process.env.VUE_APP_API_URL_LOAD_USER + payload._id, payload, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      })
        .then(res => {
          console.log('res', res.data)
          commit('setLoading')
          if (res.data.status == 200) {
            commit('clearSnackAlert')
            commit('setSnackAlert', {
              status: true,
              success: true,
              error: false,
              message: '<strong>Votre profile</strong> a été mise à jours avec succès.'
            })
            commit('setUser', JSON.parse(JSON.stringify(res.data.data)))
            localStorage.setItem('currentUser', JSON.stringify(res.data.data))
            // if ('newEmail' in payload)
            //   return true
          } else throw new Error(res.data)
        }
        ).catch(error => {
          console.log('error', error.message)
          commit('clearSnackAlert')
          commit('setSnackAlert', {
            status: true,
            success: false,
            error: true,
            message: '<strong>Erreur:</strong> ' + error.message
          })
          commit('clearError')
          commit('setError', error)
        })
    },
    async updateCover({ commit }, payload) {
      commit('setLoading')
      let formData = new FormData()
      formData.append('photoURL', payload.image)
      formData.append('oldURL', payload.old)
      formData.append('id', payload.id)
      await Axios.put(process.env.VUE_APP_API_URL_UPDATE_COVER, formData, {
        headers: {
          'Content-Type': 'applicatison',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      })
        .then(res => {
          commit('clearSnackAlert')
          commit('setSnackAlert', {
            status: true,
            success: true,
            error: false,
            message: '<strong>Votre profile</strong> a été mise à jours avec succès.'
          })
          commit('setLoading')
          commit('setUser', JSON.parse(JSON.stringify(res.data.data)))
          localStorage.setItem('currentUser', JSON.stringify(res.data.data))
        }
        ).catch(error => {
          commit('clearSnackAlert')
          commit('setSnackAlert', {
            status: true,
            success: false,
            error: true,
            message: '<strong>Erreur:</strong> ' + error.message
          })
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    },
    async saveExperience({ commit, getters }, payload) {
      commit('setLoading')
      await Axios.put(process.env.VUE_APP_API_URL_SAVE_EXPERIENCE + getters.user.coach._id,
        payload)
        .then(res => {
          commit('addExperience', JSON.parse(JSON.stringify(res.data.data.experience)))
          localStorage.setItem('currentUser', JSON.stringify(getters.user))
          commit('clearSnackAlert')
          commit('setSnackAlert', {
            status: true,
            success: true,
            error: false,
            message: '<strong>Vos expériences</strong> ont été mise à jours avec succès.'
          })
          commit('setLoading')
        }
        ).catch(error => {
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    },
    async saveDiploma({ commit, getters }, payload) {
      commit('setLoading')
      let formData = new FormData()
      formData.append('diplomaName', payload.diplomaName)
      formData.append('institute', payload.institute)
      formData.append('file', payload.file)
      formData.append('type', payload.type)
      await Axios.put(process.env.VUE_APP_API_URL_SAVE_DIPLOMA + getters.user[getters.user.type]._id,
        formData)
        .then(res => {
          commit('addDiploma', JSON.parse(JSON.stringify(res.data.data.diploma)))
          commit('setLoading')
          commit('clearSnackAlert')
          commit('setSnackAlert', {
            status: true,
            success: true,
            error: false,
            message: '<strong>Votre diplome</strong> a été mise à jours avec succès.'
          })
        }
        ).catch(error => {
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    },
    async bookCoach({ commit }, payload) {
      commit('setLoading')
      await Axios.put(process.env.VUE_APP_API_URL_LOAD_USER + payload.user._id, payload.user)
        .then(async res => {
          commit('setUser', JSON.parse(JSON.stringify(res.data.data)))
          localStorage.setItem('currentUser', JSON.stringify(res.data.data))
          const objectifsList = ['loose-weight', 'gain-muscles', 'fitness']

          await Axios.post(process.env.VUE_APP_API_URL_BOOK_COACH, {
            user: payload.user._id,
            coach: payload.coachId,
            objectif: objectifsList[payload.objectif]
          }).then(res => {
            commit('setLoading')
            commit('clearSnackAlert')
            commit('setSnackAlert', {
              status: true,
              success: true,
              error: false,
              message: '<strong>Votre demande</strong> a été envoyé.'
            })

          }).catch(error => {
            commit('setLoading')

          })
        }
        ).catch(error => {
          commit('clearSnackAlert')
          commit('setSnackAlert', {
            status: true,
            success: false,
            error: true,
            message: '<strong>Erreur:</strong> ' + error.message
          })
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    },
    async requestLiveCoach({ commit, getters }, payload) {
      commit('setLoading')
      payload.user = getters.user._id;
      const objectifsList = ['loose-weight', 'gain-muscles', 'fitness']
      await Axios.post(process.env.VUE_APP_API_URL_COACHING_REQUEST, {
        user: payload.user,
        coach: payload.coachId,
        packId: payload.packId,
        firstSession: payload.firstSession,
        objectif: objectifsList[payload.objectif]
      })
        .then(res => {
          commit('setLoading')
          commit('setUser', JSON.parse(JSON.stringify(res.data.data)));
          localStorage.setItem('currentUser', JSON.stringify(res.data.data));
          commit('clearSnackAlert')
          commit('setSnackAlert', {
            status: true,
            success: true,
            error: false,
            message: '<strong>Votre demande</strong> a été envoyé.'
          })
        }
        ).catch(error => {
          commit('clearSnackAlert')
          commit('setSnackAlert', {
            status: true,
            success: false,
            error: true,
            message: '<strong>Erreur:</strong> ' + error.message
          })
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    },

  }
}
